export const CLOUDFRONT_URL = 'https://d2zx9p7viy4o0o.cloudfront.net';
